import React from 'react'
import * as d3 from './d3.modified.js'

export default class Link extends React.PureComponent {
    constructor(props) {
        super(props)
        this.props.linkItem._jsx = {
            styleSelect: this.styleSelect,
            styleDeselect: this.styleDeselect,
            styleFromNodeMove: this.styleFromNodeMove,
            styleToNodeMove: this.styleToNodeMove,
            styleFade: this.styleFade
        }
    }

    componentDidUpdate() {
        this.styleFromNodeMove()
    }

    componentDidMount() {
        this.props.linkItem.refs.holder
            .transition()
                .duration(500)
                .style('opacity', 1)

        this.props.linkItem.refs.mouseCatcher
            .on("click", ()=>{
                this.props.keyPressDict.link = false
                d3.event.stopPropagation()
                this.props.clickHandler(this.props.linkItem)
            })

        this.styleFromNodeMove()
    }

    styleFade = () => {
        this.props.linkItem.refs.holder
            .transition()
                .duration(200)
                .style('opacity', 0)
    }

    styleFromNodeMove = () => {
        var link = this.props.linkItem
        var _ = (a,b,c) => {this.props.enqueueAttrChange({elem:a,attr:b,val:c})}
        _(link.refs.line, 'x1', link.x1)
        _(link.refs.line, 'y1', link.y1)
        _(link.refs.mouseCatcher, 'x1', link.x1)
        _(link.refs.mouseCatcher, 'y1', link.y1)
        if (link.type==='parent-child') {
            // _(link.refs.marker, 'x', (link.x1+link.x2)*0.5)
            // _(link.refs.marker, 'y', (link.y1+link.y2)*0.5)
            _(link.refs.marker, 'transform', `rotate(${Math.atan2((link.y1-link.y2),(link.x1-link.x2))* 180 / Math.PI + 45 + 180} ${(link.x1+link.x2)*0.5} ${(link.y1+link.y2)*0.5}) translate(${(link.x1+link.x2)*.5} ${(link.y1+link.y2)*.5})`)
        } else if (link.type==='reference') {
            _(link.refs.marker, 'cx', (link.x1+link.x2)*0.5)
            _(link.refs.marker, 'cy', (link.y1+link.y2)*0.5)
        }
    }

    styleToNodeMove = () => {
        var link = this.props.linkItem
        var _ = (a,b,c) => {this.props.enqueueAttrChange({elem:a,attr:b,val:c})}
        _(link.refs.line, 'x2', link.x2)
        _(link.refs.line, 'y2', link.y2)
        _(link.refs.mouseCatcher, 'x2', link.x2)
        _(link.refs.mouseCatcher, 'y2', link.y2)
        if (link.type==='parent-child') {
            // _(link.refs.marker, 'x', (link.x1+link.x2)*0.5)
            // _(link.refs.marker, 'y', (link.y1+link.y2)*0.5)
            _(link.refs.marker, 'transform', `rotate(${Math.atan2((link.y1-link.y2),(link.x1-link.x2))* 180 / Math.PI + 45 + 180} ${(link.x1+link.x2)*0.5} ${(link.y1+link.y2)*0.5}) translate(${(link.x1+link.x2)*.5} ${(link.y1+link.y2)*.5})`)
        } else if (link.type==='reference') {
            _(link.refs.marker, 'cx', (link.x1+link.x2)*0.5)
            _(link.refs.marker, 'cy', (link.y1+link.y2)*0.5)
        }
    }

    styleSelect = () => {
        this.props.enqueueClassChange({
            elem: this.props.linkItem.refs.line,
            class: 'active',
            val: true,
        })
    }

    styleDeselect = () => {
        this.props.enqueueClassChange({
            elem: this.props.linkItem.refs.line,
            class: 'active',
            val: false,
        })
    }

    render () {
        var link = this.props.linkItem
        link.refs = {}

        const diffColors = {
            none: "#fff",
            yellow: "#FFFFE6",
            green: "#E6FFED",
            red: "#FFEEF0"
        }

        if ('similarity'===link.type) {
            return (
                <g ref={c=>link.refs.holder=d3.select(c)} opacity="0">
                    <line
                        ref={c=>link.refs.mouseCatcher=d3.select(c)}
                        x1={link.x1}
                        y1={link.y1}
                        x2={link.x2}
                        y2={link.y2}
                        className="node-link-mouseCatcher"
                        id={`L_${link.id}`}
                    />
                    <line
                        ref={c=>link.refs.line=d3.select(c)}
                        x1={link.x1}
                        y1={link.y1}
                        x2={link.x2}
                        y2={link.y2}
                        className={`node-link ${link._compareType?'node-link-diff-'+link._compareType:''}`}
                        strokeWidth="1"
                    />
                </g>
            )
        } else if ('parent-child'===link.type) {
            return (
                <g ref={c=>link.refs.holder=d3.select(c)} opacity="0">
                    <line
                        ref={c=>link.refs.mouseCatcher=d3.select(c)}
                        x1={link.x1}
                        y1={link.y1}
                        x2={link.x2}
                        y2={link.y2}
                        className="node-link-mouseCatcher"
                        id={`L_${link.id}`}
                    />
                    <line
                        ref={c=>link.refs.line=d3.select(c)}
                        x1={link.x1}
                        y1={link.y1}
                        x2={link.x2}
                        y2={link.y2}
                        className={`node-link ${link._compareType?'node-link-diff-'+link._compareType:''}`}
                        strokeWidth="1"
                    >
                    </line>
                    <g
                        ref={c=>link.refs.marker=d3.select(c)}
                        transform={`translate(${(link.x1+link.x2)*.5} ${(link.y1+link.y2)*.5})`}
                        className={`node-link-marker ${link._compareType?'node-link-diff-'+link._compareType:''}`}
                    >
                        <path d="M 3,3 L 3,-3 -3,-3"/>
                    </g>
                </g>
            )
        } else/* if ('reference'===link.type)*/ {
            return (
                <g ref={c=>link.refs.holder=d3.select(c)} opacity="0">
                    <line
                        ref={c=>link.refs.mouseCatcher=d3.select(c)}
                        x1={link.x1}
                        y1={link.y1}
                        x2={link.x2}
                        y2={link.y2}
                        className="node-link-mouseCatcher"
                        id={`L_${link.id}`}
                    />
                    <line
                        ref={c=>link.refs.line=d3.select(c)}
                        x1={link.x1}
                        y1={link.y1}
                        x2={link.x2}
                        y2={link.y2}
                        className={`node-link ${link._compareType?'node-link-diff-'+link._compareType:''}`}
                        strokeWidth="1"
                    />
                    <circle
                        ref={c=>link.refs.marker=d3.select(c)}
                        cx={(link.x1+link.x2)*0.5}
                        cy={(link.y1+link.y2)*0.5}
                        r="5"
                        className={`node-link-marker ${link._compareType?'node-link-diff-'+link._compareType:''}`}
                    />
                </g>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Link.js